
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import Axios from 'axios';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Pedidos: Pedido[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Pedidos.Tipos.toTipo( a ), Pedidos: items[a] } );
            }
            return e;
        }

        public get Estado() { return this.Controlador.Buscador.Estado; }



        Cerrar()
        {
            this.Seleccionados.clear();
        }

        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return (
                this.Seleccionados.filter( x => x.Tipo.Id == Pedidos.Tipos.MercadoLibre.Id && x.Envio.EstadoPlataforma == 'ready_to_ship' ).hasRows() ||
                this.Seleccionados.filter( x => x.Envio.Tipo.esTreggo ).hasRows() ||
                this.Seleccionados.filter( x => x.Tipo.esNecxus ).hasRows() ||
                this.Seleccionados.filter( x => x.Envio.Tipo.esPickit ).hasRows() ||
                this.Seleccionados.filter( x => x.Envio.Tipo.esEnvioPack ).hasRows()

            );
        }

        public async Ejecutar()
        {

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            await Pedido.DescargarEtiquetasEnvios( this.Seleccionados );
            Utiles.GenerandoArchivo( false );
            this.Cargando = false;
        }
    }
